export default {
      id: "txt_redo-usage",
      viewBox: "0 0 16 16",
      url: __webpack_public_path__ + "img/icons.a12b6041.svg#txt_redo",
      toString: function () {
        return this.url;
      }
    }